export default __webpack_public_path__ + "static/media/DataCuration.f61c9013.svg";